

/* ===============================
   CART INTEGRITY – GLOBAL SCRIPT
================================ */

async function limpiarGarantiasHuerfanasGlobal() {
  try {
    const res = await fetch('/cart.js');
    const cart = await res.json();
    if (!cart?.items) return;

    const mainProductIds = cart.items.map(item =>
      item.variant_id.toString()
    );

    const orphanWarranties = cart.items.filter(item =>
      item.properties?.main_product_id &&
      !mainProductIds.includes(item.properties.main_product_id)
    );

    let seEliminoGarantia = false;

    for (const warranty of orphanWarranties) {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          id: warranty.key,
          quantity: 0
        })
      });
      seEliminoGarantia = true;
    }

    if (seEliminoGarantia) {
      // 🔄 Obtener carrito actualizado
      const updatedCartRes = await fetch('/cart.js');
      const updatedCart = await updatedCartRes.json();

      // 🔔 Mostrar mensaje
      mostrarPopupGarantia();

      // ♻️ Forzar refresco visual del mini‑cart
      document.dispatchEvent(
        new CustomEvent('cart:updated', {
          detail: { cart: updatedCart }
        })
      );
    }

    ocultarCantidadGarantiasYPrincipales(cart);
  } catch (err) {
    console.error('❌ Error limpiando garantías huérfanas:', err);
  }
}

/* Ejecutar al cargar cualquier página */
document.addEventListener('DOMContentLoaded', () => {
  limpiarGarantiasHuerfanasGlobal();
});

/* Interceptor GLOBAL de cambios de carrito */
(function () {
  const originalFetch = window.fetch;

  window.fetch = async (...args) => {
    const response = await originalFetch(...args);
    const resource = args[0];

    if (
      typeof resource === 'string' &&
      (
        resource.includes('/cart/add') ||
        resource.includes('/cart/change') ||
        resource.includes('/cart/update')
      )
    ) {
      setTimeout(() => {
        limpiarGarantiasHuerfanasGlobal();
      }, 400);
    }

    return response;
  };
})();

/* Escuchar actualizaciones de carrito */
document.addEventListener('cart:updated', async (e) => {
  try {
    // 🔄 Refrescar visualmente el mini‑cart usando Sections API
    const res = await fetch('/?sections=cart-drawer');
    const data = await res.json();

    const cartDrawer = document.querySelector('#CartDrawer');
    if (cartDrawer && data['cart-drawer']) {
      const parser = new DOMParser();
      const newDoc = parser.parseFromString(data['cart-drawer'], 'text/html');
      const newContent = newDoc.querySelector('#CartDrawer .hdt-mini-cart__items');

      if (newContent) {
        const currentContent = cartDrawer.querySelector('.hdt-mini-cart__items');
        if (currentContent) {
          currentContent.replaceWith(newContent);
        } else {
          const drawerInner = cartDrawer.querySelector('.hdt-mini-cart__inner') || cartDrawer;
          drawerInner.appendChild(newContent);
        }
      }

      // Forzar apertura del drawer
      cartDrawer.setAttribute('open', '');
      cartDrawer.removeAttribute('hidden');
      cartDrawer.classList.remove('hdt-hidden');
      cartDrawer.style.display = 'block';
    }

    // 🔢 Actualizar contador
    const cartCountBox = document.querySelector('.hdt-count-box');
    if (cartCountBox && e.detail?.cart?.item_count !== undefined) {
      cartCountBox.textContent = e.detail.cart.item_count;
    }

    // 🔒 Ocultar cantidades correctamente
    if (e.detail?.cart) {
      ocultarCantidadGarantiasYPrincipales(e.detail.cart);
    }

  } catch (err) {
    console.error('❌ Error refrescando mini‑cart:', err);
  }
});

/* Ocultar cantidades */
function ocultarCantidadGarantiasYPrincipales(cart) {
  const cartItems = document.querySelectorAll('.hdt-mini-cart__item');

  cartItems.forEach(item => {
    const metaList = item.querySelector('.hdt-mini-cart_meta_propertyList');
    const qtyWrapper = item.querySelector('.hdt-mini-cart__quantity');
    if (!qtyWrapper) return;

    const isGarantia =
      metaList && metaList.textContent.includes('main_product_id');

    const variantLink = item.querySelector('.hdt-mini-cart__title, a.hdt-mini-cart__title');
    const variantIdMatch = variantLink?.href?.match(/variant=(\d+)/);
    const variantId = variantIdMatch ? variantIdMatch[1] : null;

    const isPrincipalConGarantia =
      variantId &&
      cart.items.some(
        g => g.properties?.main_product_id?.toString() === variantId.toString()
      );

    if (isGarantia || isPrincipalConGarantia) {
      qtyWrapper.style.display = 'none';
      qtyWrapper.classList.add('hdt-quantity-hidden');
    }
  });
}

document.addEventListener('garantia:eliminada', () => {
  if (typeof mostrarPopupGarantia === 'function') {
    mostrarPopupGarantia();
  }
});

//Función para mostrar popup
function mostrarPopupGarantia() {
  if (document.querySelector('.popup-garantia-alert')) return;

  const popup = document.createElement('div');
  popup.className = 'popup-garantia-alert';
  popup.innerHTML = `
    <div class="popup-garantia-content">
      <strong>⚠️ Atención</strong><br>
      No puedes comprar solo la garantía. Ha sido eliminada del carrito.
    </div>
  `;
  document.body.appendChild(popup);

  setTimeout(() => popup.classList.add('visible'), 50);
  setTimeout(() => {
    popup.classList.remove('visible');
    setTimeout(() => popup.remove(), 400);
  }, 1500);
}

function mostrarPopupProductoExistente() {
  if (document.querySelector('.popup-producto-existente')) return;

  const popup = document.createElement('div');
  popup.className = 'popup-producto-existente';
  popup.innerHTML = `
    <div class="popup-garantia-content">
      <strong>⚠️ Atención</strong><br>
      Ya tienes este producto con su garantía en el carrito.
    </div>
  `;
  document.body.appendChild(popup);

  setTimeout(() => popup.classList.add('visible'), 50);
  setTimeout(() => {
    popup.classList.remove('visible');
    setTimeout(() => popup.remove(), 400);
  }, 3500);
}


// Estilos del popup
const style = document.createElement('style');
style.textContent = `
.popup-garantia-alert {
  position: fixed;
  top: 20px;
  right: 20px;
  background: #fff3cd;
  color: #856404;
  border: 1px solid #ffeeba;
  padding: 12px 16px;
  border-radius: 6px;
  font-size: 14px;
  font-family: inherit;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
  opacity: 0;
  transform: translateY(-10px);
  transition: all 0.4s ease;
  z-index: 9999;
}
.popup-garantia-alert.visible {
  opacity: 1;
  transform: translateY(0);
}
.popup-garantia-content strong {
  font-weight: 600;
}
  .popup-producto-existente {
  position: fixed;
  top: 20px;
  right: 20px;
  background: #f8d7da;
  color: #721c24;
  border: 1px solid #f5c6cb;
  padding: 12px 16px;
  border-radius: 6px;
  font-size: 14px;
  font-family: inherit;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
  opacity: 0;
  transform: translateY(-10px);
  transition: all 0.4s ease;
  z-index: 9999;
}
.popup-producto-existente.visible {
  opacity: 1;
  transform: translateY(0);
}
  .hdt-quantity-disabled {
    opacity: 0.5;
    pointer-events: none;
  }
  .hdt-quantity-disabled button,
  .hdt-quantity-disabled input {
    cursor: not-allowed !important;
  }
  .hdt-quantity-hidden {
    display: none !important;
    visibility: hidden !important;
  }
`;
document.head.appendChild(style);